// extracted by mini-css-extract-plugin
export default {"searchBox":"search_searchBox__U8ErK","searchIcon":"search_searchIcon__KFtUq","searchInput":"search_searchInput__afGgN"};